module.exports = __webpack_public_path__ + "static/img/friend8.c06f7d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/friend8.png
// module id = eSFg
// module chunks = 1